import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import contact from './modules/contact'
import client from './modules/client'
import addresses from './modules/addresses'
import references from './modules/references'
import companies from './modules/companies'
import subcategories from './modules/subcategories'
import products from './modules/products'
import skus from './modules/skus'
import companySkus from './modules/company_skus'
import texts from './modules/texts'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state,
  actions,
  getters,
  mutations,
  modules: {
    contact,
    client,
    addresses,
    references,
    companies,
    subcategories,
    products,
    skus,
    companySkus,
    texts
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js